import { AssetImageDto, FieldTranslation } from '../../models';

export enum LabelsLocation {
    topLeft = 'top-left',
    topRight = 'top-right',
    bottomLeft = 'bottom-left',
    bottomRight = 'bottom-right',
}

export interface Label {
    label: FieldTranslation;
    location: LabelsLocation;
    color?: string;
    bgColor: string;
    icon?: AssetImageDto;
}
